import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { BUILDING_FORM_FIELD_NAME_CONTRACT_START } from '../../BuildingForm.constants'

function ContractStartDateField() {
  const { t } = useTranslation()
  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.StartDateLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={BUILDING_FORM_FIELD_NAME_CONTRACT_START}
      placeholder={t('Building.StartDatePlaceholderKey')}
    />
  )
}

export default ContractStartDateField
